// Fields the profile download serializers read off query results.
//
// Every entry here must also be selected by the corresponding GraphQL fragment. If it is not,
// the serializer reads `undefined`, the key is dropped from the downloaded JSON, and the
// subsequent upload — which writes with a whole-document replace — erases the stored value.
//
// serialized-fields.test.js enforces the fragment/serializer agreement.
//
// These lists mirror `included` in graphql-server's
// src/lib/admin/profile-transfer/profile-transfer-fields.ts, expressed in the wire shape the
// fragments use — so `validators`, not the stored `staticValidations`/`lookupValidations`.

const SERIALIZED_FIELDS = {
  exportMapping: [
    'label',
    'widthChars',
    'field',
    'formatter',
    'formatterArg',
    'formula',
    'cellType',
    'hide',
    'order',
    'locked',
    'columnStyles',
    'headerStyles',
  ],
  // No `dateFormats`: the server always recomputes it in
  // ImportManager.formatImportMapping from the profile's dateFormats based on dataType, so a
  // value carried in the file would be discarded.
  importMapping: [
    'saName',
    'externalName',
    'intermediateHeaderName',
    'dataType',
    'required',
    'validators',
    'padStart',
    'operation',
    'order',
  ],
  importDefault: ['saName', 'externalName', 'dataType', 'defaultValues'],
  dataTableColumn: [
    'field',
    'displayName',
    'visible',
    'sortable',
    'defaultSort',
    'defaultSortDirection',
    'formatter',
    'editFormatter',
    'baseType',
    'path',
  ],
};

export default SERIALIZED_FIELDS;
